import { render, staticRenderFns } from "./lt-logo.vue?vue&type=template&id=5d93208b&scoped=true"
var script = {}
import style0 from "./lt-logo.vue?vue&type=style&index=0&id=5d93208b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d93208b",
  null
  
)

export default component.exports